import React, { FC, memo, useCallback } from 'react'

interface Props {
  disabled: boolean
  onChange(up: false): void
}

const BtnQtyDown: FC<Props> = ({ disabled, onChange }) => {
  const handleClick = useCallback(() => onChange(false), [onChange])

  return (
    <button className="quantity-button / quantity-down" disabled={disabled} type="button" onClick={handleClick}>
      <svg className="sociavore-icon" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="8" x2="16" y1="12" y2="12"></line>
      </svg>
    </button>
  )
}

export default memo(BtnQtyDown)
